import { render, staticRenderFns } from "./FileDropper.vue?vue&type=template&id=b85521a6&"
import script from "./FileDropper.vue?vue&type=script&lang=js&"
export * from "./FileDropper.vue?vue&type=script&lang=js&"
import style0 from "./FileDropper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports